import { formatNumber } from '@/helpers/format-number'
import * as product from '@/services/rest-api/lib/product/product'
import store from '@/state/store'

const hasAccessAll = store.getters['identity/hasAccessAll']

const quantityValidationNew = [
  ['bail'],
  'required',
  'number',
  ['decimal', 3],
  ['min', 0.001, 'value'],
  ['max', 10000000, 'value'],
]

const translate = (t, key, fallback, params = {}) => {
  if (typeof t !== 'function') return fallback

  const translated = t(key, params)

  return translated === key ? fallback : translated
}

export const getLoadFieldsDefault = (t) => [
  {
    name: 'product_id',
    key: 'product.name',
    label: translate(t, 'delivery.loadsTable.fields.productName', 'Nama Produk'),
    placeholder: translate(t, 'delivery.loadsTable.placeholder.selectProduct', 'Pilih Produk'),
    modalTitle: translate(t, 'delivery.loadsTable.placeholder.selectProduct', 'Pilih Produk'),
    isEditable: true,
    isSortable: true,
    type: 'value-help',
    validation: 'required',
    trackBy: 'id',
    displayedBy: 'name',
    listGetter: product.get,
    getInitialObject: (obj) => obj,
    thStyle: 'width: 250px',
    tableFields: [
      {
        label: translate(t, 'delivery.loadsTable.fields.productName', 'Nama Produk'),
        key: 'name',
        isSortable: true,
      },
      {
        label: translate(t, 'delivery.fields.minTemperature', 'Min. Temperatur'),
        key: 'product_type.product_category.min_temperature',
        isSortable: true,
        formatter: (value) => ((value ?? '') === '' ? '-' : `${value} °C`),
        scopes: ['tms-cold-chain:read'],
      },
      {
        label: translate(t, 'delivery.fields.maxTemperature', 'Max. Temperatur'),
        key: 'product_type.product_category.max_temperature',
        isSortable: true,
        formatter: (value) => ((value ?? '') === '' ? '-' : `${value} °C`),
        scopes: ['tms-cold-chain:read'],
      },
      {
        label: translate(t, 'delivery.loadsTable.fields.productType', 'Jenis Produk'),
        key: 'product_type.name',
        isSortable: true,
      },
      {
        label: translate(t, 'delivery.fields.productCategory', 'Kategori Produk'),
        key: 'product_type.product_category.name',
        isSortable: true,
      },
    ],
  },
  {
    name: 'product_type',
    key: 'product.product_type.name',
    label: translate(t, 'delivery.loadsTable.fields.productType', 'Jenis Produk'),
    isSortable: true,
    thStyle: 'width: 150px',
  },
  {
    name: 'product_category',
    key: 'product.product_type.product_category.name',
    label: translate(t, 'delivery.fields.productCategory', 'Kategori Produk'),
    isSortable: true,
    thStyle: 'width: 150px',
  },
  {
    name: 'quantity',
    key: 'quantity',
    label: translate(t, 'delivery.loadsTable.fields.quantity', 'Kuantitas'),
    _type: 'number',
    placeholder: translate(
      t,
      'delivery.loadsTable.placeholder.enterQuantity',
      'Masukkan Kuantitas'
    ),
    validation: quantityValidationNew,
    'validation-messages': {
      required: 'Wajib diisi',
      number: 'Harus berupa angka',
      min: 'Harus lebih dari 0',
      max: 'Maksimal 10,000,000',
      decimal: 'Angka di belakang koma tidak boleh lebih dari 3 digit',
    },
    value: 1,
    isEditable: true,
    isSortable: true,
    thStyle: 'width: 150px',
  },
  {
    name: 'uom',
    key: 'uom',
    label: translate(t, 'delivery.loadsTable.fields.unit', 'Satuan'),
    placeholder: translate(t, 'delivery.loadsTable.placeholder.selectUnit', 'Pilih Satuan'),
    isEditable: true,
    validation: 'required',
    type: 'select-resourceful',
    trackBy: 'name',
    optionsGetter: null,
    optionLabelFn: ({ item }) => item.name,
    getInitialObject: (obj) => obj?.uom ?? obj,
    thStyle: 'width: 130px',
  },
  {
    name: 'total_weight',
    key: 'total_weight',
    label: translate(t, 'delivery.loadsTable.fields.weight', 'Berat'),
    isSortable: true,
    afterText: 'Kg',
    thStyle: 'width: 200px',
  },
  {
    name: 'total_volume',
    key: 'total_volume',
    label: translate(t, 'delivery.fields.volume', 'Volume'),
    isSortable: true,
    afterText: 'Cbm',
    thStyle: 'width: 200px',
  },
  {
    label: translate(t, 'delivery.fields.minTemperature', 'Min. Temperatur'),
    key: 'min_temperature',
    isSortable: true,
    formatter: (value) => ((value ?? '') === '' ? '-' : `${value} °C`),
    scopes: ['tms-cold-chain:read'],
    thStyle: 'width: 200px',
  },
  {
    label: translate(t, 'delivery.fields.maxTemperature', 'Max. Temperatur'),
    key: 'max_temperature',
    isSortable: true,
    formatter: (value) => ((value ?? '') === '' ? '-' : `${value} °C`),
    scopes: ['tms-cold-chain:read'],
    thStyle: 'width: 200px',
  },
  {
    name: 'note',
    key: 'note',
    label: translate(t, 'delivery.loadsTable.fields.notes', 'Catatan'),
    placeholder: translate(t, 'delivery.loadsTable.placeholder.writeHere', 'Tulis di sini...'),
    isEditable: true,
    type: 'text',
    validationName: translate(t, 'delivery.loadsTable.fields.notes', 'Catatan'),
    validation: 'max:255,length',
    'validation-messages': {
      max: translate(
        t,
        'delivery.loadsTable.validation.note.max',
        'Catatan tidak boleh lebih dari 255 karakter'
      ),
    },
    thStyle: 'width: 200px',
  },
]

const getStatusFields = (t) => {
  let loadFieldsSend = [
    {
      name: 'product_name_type',
      key: 'product.name',
      label: translate(t, 'delivery.loadsTable.fields.productName', 'Nama Produk'),
      thStyle: 'width: 200px',
    },
    {
      name: 'product_category',
      key: 'product.product_type.product_category.name',
      label: translate(t, 'delivery.fields.productCategory', 'Kategori Produk'),
      isSortable: true,
      thStyle: 'width: 150px',
    },
    {
      key: 'quantity',
      label: translate(t, 'delivery.loadsTable.fields.quantity', 'Kuantitas'),
      thStyle: 'width: 200px;justify-items: center;',
      tdClass: 'text-center align-middle',
      formatter: (_, item) => {
        return `${formatNumber(item?.quantity) ?? '-'}${item?.quantity ? ` ${item?.uom}` : ''}`
      },
    },
    {
      key: 'total_weight',
      label: translate(t, 'delivery.loadsTable.fields.weightAndVolume', 'Berat dan Volume'),
      thStyle: 'width: 200px;justify-items: center;',
      tdClass: 'text-center align-middle',
      formatter: (_, item) => {
        return `${!isNaN(item?.total_weight) ? formatNumber(item?.total_weight) : '-'} Kg • ${
          !isNaN(item?.total_volume) ? formatNumber(item?.total_volume) : '-'
        } Cbm`
      },
    },
  ]

  if (hasAccessAll(['tms-cold-chain:read'])) {
    loadFieldsSend = [
      ...loadFieldsSend,
      {
        key: 'min_temperature',
        label: translate(t, 'delivery.fields.minTemperature', 'Min. Temperatur'),
        thStyle: 'width: 200px',
        tdClass: 'align-middle',
        isSortable: true,
        formatter: (value) => ((value ?? '') === '' ? '-' : `${value} °C`),
      },
      {
        key: 'max_temperature',
        label: translate(t, 'delivery.fields.maxTemperature', 'Max. Temperatur'),
        thStyle: 'width: 200px',
        tdClass: 'align-middle',
        isSortable: true,
        formatter: (value) => ((value ?? '') === '' ? '-' : `${value} °C`),
      },
    ]
  }

  loadFieldsSend = [
    ...loadFieldsSend,
    {
      key: 'note',
      name: 'note',
      label: translate(t, 'delivery.loadsTable.fields.notes', 'Catatan'),
      thStyle: 'width: 200px',
      tdClass: 'align-middle',
    },
  ]

  return loadFieldsSend
}

export const getLoadFieldsByStatus = (t) => ({
  Dikonfirmasi: getStatusFields(t),
  Dijadwalkan: getStatusFields(t),
  Dijalankan: getStatusFields(t),
  Diambil: getStatusFields(t),
})
